

import { useMemo } from "react";
import { IBigscreenSettings, IEventField } from "../constants/interfaces";
import computeEventFields from "./computeEventFields";

const useEventFields = (bigscreenSettings?: Array<IBigscreenSettings>): Array<IEventField> | undefined  => {
    const eventFields = useMemo(() => {
        if (!bigscreenSettings) return undefined;

        return computeEventFields(bigscreenSettings);
    }, [bigscreenSettings])

    return eventFields;
};

export default useEventFields;
